function modal() {
    var modal = document.querySelector('.modal'), 
        modalClose = document.querySelectorAll('.modal__close'),
        modalTrigger = document.querySelectorAll('.modal__trigger'),
        body = document.querySelector('body')

    modalTrigger.forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            body.classList.add('overflow--hidden')
            modal.classList.add('modal--active')
        })
    })

    modalClose.forEach(function (el) {
        el.addEventListener('click', function(e) {
            closeModal(e)
        })
    })

    modal.addEventListener('click', function(event) {
        if(!document.querySelector('.modal__box').contains(event.target)) {
            closeModal(event)
        }
    })
}

function closeModal(event) {
    var parent = event.target.closest('.modal')
    body.classList.remove('overflow--hidden')
    parent.classList.remove('modal--active')
}